// extracted by mini-css-extract-plugin
export default {"heroBg":"HeroSection_heroBg__qujAZ","heroOverlay":"HeroSection_heroOverlay__SCTCk","scriptFont":"HeroSection_scriptFont__Qgkt0","heroLogo":"HeroSection_heroLogo__VxosU"};